import React from "react";
import { connect } from "react-redux";
import Dropdown from "./Dropdown/etsDD";
import PropTypes from "prop-types";
import Authorization from "../../../utility/authorization";

/**
 * Class to retrive operators Dropdown
 */
class BranchListDD extends React.Component {
  render() {
    const { name, onBlur, onChange, value, dataValidationName, ...rest } =
      this.props;
    return (
      <Dropdown
        options={
          Authorization.getBranchAccess() &&
          Authorization.getBranchAccess().length &&
          Authorization.getBranchAccess().map(type => ({
            label: type.partnerCode,
            value: type.userId
          }))
        }
        optionOnChange={onChange}
        value={value}
        name={name}
        className="form-control dd-btn"
        dataValidationName={dataValidationName}
        {...rest}
      />
    );
  }
}
BranchListDD.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default BranchListDD;
